import { render } from "./FormPreview.vue?vue&type=template&id=75a452c8&scoped=true&ts=true"
import script from "./FormPreview.vue?vue&type=script&lang=ts"
export * from "./FormPreview.vue?vue&type=script&lang=ts"

import "./FormPreview.vue?vue&type=style&index=0&id=75a452c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a452c8"]])

export default __exports__